<ng-container *ngIf="_planSummaries">
    <div class="cardLoCHeader">
        <!--<div class="cardLoC" id="LoCName">
        {{LoC}}
    </div>-->
        <div class="cardLoC" id="LoCName">
            Carriers
        </div>
        <span class="infoText">Please select one of the carriers below and select plans you want to make available in your online enrollment.</span>
        <div class="cardLoCDesc">
            {{LoCDescriptions[LoC]}}
        </div>
    </div>
    <div class="cardBox">
        
        <div class="planCard" *ngFor="let carrier of _voluntaryCarriers">
            <mat-radio-group name="opList" (click)="onRadioChange($event,carrier.code)">
                <app-plan-card
                    [voluntaryCarrier]="carrier"
                    [isSelected]="isAnySelected()"
                    [isPlanSelected] ="anyPlanSelected()"
                    [carrierSelect] ="carrierToSelect"
                    (click)="masterToggle($event)"
                    [sendDataToPlanCard]="eventFromPlanCardGroup()"> </app-plan-card>
            </mat-radio-group>
        </div>
        <div class="filterControls">
            <mat-checkbox *ngIf="hasOfflinePlans" (change)="filterOffline($event.checked)" [labelPosition]="'after'" [checked]="showOfflinePlans" class="offlineCheckbox">
                Show Offline Plans
            </mat-checkbox>
            <mat-form-field>
                <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Search...">
            </mat-form-field>
        </div>
        <div>
            <ng-container *ngIf="!_showPlanGrid">
                <span class="noPlans">Please select a carrier to see plans.</span>
            </ng-container>
            <ng-container *ngIf="_showPlanGrid">
                <table mat-table matSort [dataSource]="filteredDataSource" class="mat-elevation-z8" style="table-layout: auto">

                    <!-- Checkbox Column -->
                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef>
                            <mat-checkbox (change)="$event ? masterToggle() : null"
                                          [checked]="selection.hasValue() && isAllSelected()"
                                          [indeterminate]="selection.hasValue() && !isAllSelected()">
                            </mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let row">
                            <mat-checkbox (click)="$event.stopPropagation()"
                                          (change)="$event ? selection.toggle(row) : null"
                                          [checked]="selection.isSelected(row)">
                            </mat-checkbox>
                        </td>
                    </ng-container>

                    <!--- Note that these columns can be defined in any order.
        The actual rendered columns are set as a property on the row definition" -->
                    <!-- Carrier Column -->


                    <ng-container>

                        <ng-container matColumnDef="carrier">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Carrier </th>
                            <td mat-cell *matCellDef="let element"> {{element.carrier.name}} </td>
                        </ng-container>

                        <!-- PlanName Column -->
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Plan Name </th>
                            <td class="link-color" (click)="openPlanModal(element)" mat-cell *matCellDef="let element"> {{element.name}} </td>
                        </ng-container>

                        <!-- Type Column -->
                        <ng-container matColumnDef="type">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
                            <td mat-cell *matCellDef="let element"> {{element.type}} </td>
                        </ng-container>

                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </ng-container>
        </div>
    </div>
</ng-container>
<mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>

